import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RecentTransaction } from '../dashboard/dashboard.page';
import { PageHeaderService } from 'src/app/shared/services/page-header.service';
import { environment } from 'src/environments/environment';
import { DataSharingService } from 'src/app/core/data-sharing.service';
import { ModalController, Platform } from '@ionic/angular';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { MatSelectChange } from '@angular/material/select';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { TransactionDetailsComponent } from 'src/app/shared/components/modals/transaction-details/transaction-details.component';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMM YYYY',
  },
  display: {
    dateInput: 'MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.page.html',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  styleUrls: ['./transactions.page.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,

})
export class TransactionsPage implements OnInit {

  pageTitle = 'Transactions';
  pageSubtitle = 'Track Every Move and Understand Your Spending Smarter';
  // selectedMonthYear: Date | null = null;
  selectedMonthYear: any = new Date();
  tempSelectedDate: any = new Date().toISOString();
  selectedAccount = '';
  presentingElement: any;

  @Output() accountChanged = new EventEmitter<string>();

  constructor(
    private headerService: PageHeaderService,
    private dataSharingService: DataSharingService,
    private platform: Platform,
    private modalCtrl: ModalController,
  ) { }

  // isMobile = this.platform.is('mobile') || this.platform.is('android') || this.platform.is('ios');
  isMobile = window.innerWidth <= 768;
  isWebView = window.innerWidth > 768;
  // selectedMonthYear: Date | null = null;

  handleDateChange(event: any) {
    console.log('Date changed' + event);
    this.tempSelectedDate = new Date(event.detail.value).toISOString();
    this.selectedMonthYear = new Date(this.tempSelectedDate);
    console.log('Selected Month-Year:', this.selectedMonthYear);

  }

  setMonthAndYear(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    this.selectedMonthYear = new Date(normalizedMonth);
    this.filterTransactionsByMonth();
    datepicker.close();
  }


  chosenMonthHandler(normalizedMonth: Date, datepicker: any) {
    this.selectedMonthYear = new Date(normalizedMonth);
    this.filterTransactionsByMonth();
    datepicker.close();
  }

  setDefaultCurrentMonth() {
    const today = new Date();
    const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.selectedMonthYear = currentMonth;
  }

  // Filter transactions by selected month and year
  filterTransactionsByMonth() {
    if (!this.selectedMonthYear) {
      this.filteredTransactions = this.allTransactions;
    } else {
      // Filter by month and year
      const selectedYear = this.selectedMonthYear.getFullYear();
      const selectedMonth = this.selectedMonthYear.getMonth();

      this.filteredTransactions = this.allTransactions.filter(transaction => {
        if (!transaction.date) return false;
        const transactionDate = new Date(transaction.date);
        return transactionDate.getFullYear() === selectedYear &&
          transactionDate.getMonth() === selectedMonth;
      });
    }

    // Update pagination and display
    this.totalEntries = this.filteredTransactions.length;
    this.totalPages = Math.ceil(this.totalEntries / this.pageSize);
    this.currentPage = 1;
    this.displayedTransactions = this.filteredTransactions.slice(0, this.pageSize);
    this.dataSource.data = this.displayedTransactions;

    this.updateSummaryCardsForFilteredData(this.filteredTransactions);
  }



  // Update summary cards based on filtered transactions
  updateSummaryCardsForFilteredData(filteredTransactions: RecentTransaction[]) {
    if (filteredTransactions.length === 0) {
      this.summaryCards[2].value = '$0.00'; // This Month's Spend
      this.summaryCards[3].value = '0'; // # of Transactions This Month
      return;
    }

    // Calculate total spend for the month 
    const totalSpend = filteredTransactions.reduce((sum, transaction) => {
      const amount = transaction.amount || 0;
      return amount < 0 ? sum + amount : sum;
    }, 0);

    // Convert to positive value for display since we're showing "spend"
    this.summaryCards[2].value = this.formatCurrency(Math.abs(totalSpend));
    this.summaryCards[3].value = filteredTransactions.length.toString();
  }


  // 4 summary cards data
  summaryCards = [
    {
      label: 'Current Balance',
      value: '$0.00',
      icon: 'wallet-outline',
      imgLink: 'assets/images/inner-component/transactions/currentBalance.svg',
      bgColor: '#FFE9D5' // soft orange
    },
    {
      label: 'Available Balance',
      value: '$0.00',
      icon: 'card-outline',
      imgLink: 'assets/images/inner-component/transactions/availableBalance.svg',
      bgColor: '#D5EBFF' // soft blue
    },
    {
      label: "This Month's Spend",
      value: '$12,400.15',
      icon: 'document-text-outline',
      imgLink: 'assets/images/inner-component/transactions/monthlySpend.svg',
      bgColor: '#D5F5F6' // soft teal
    },
    {
      label: '# of Transactions This Month',
      value: '26',
      icon: 'return-down-back-outline',
      imgLink: 'assets/images/inner-component/transactions/transactions.svg',
      bgColor: '#FFD5D5' // soft red
    }
  ];


  // Accounts list for the dropdown - now dynamic
  accountsList: any[] = [];
  showAccountDropdown = false;

  onAccountChange(event: MatSelectChange) {
    this.selectedAccount = event.value;
    this.accountChanged.emit(this.selectedAccount);
    this.updateSummaryCards();
  }

  // to get current account balance data
  getCurrentAccountData() {
    if (this.accountsList.length === 0) return null;
    const selectedAccountData = this.accountsList.find(account =>
      (account.account_name + ' - ' + account.acct_last_4) === this.selectedAccount
    );

    return selectedAccountData || this.accountsList[0];
  }

  updateSummaryCards() {
    const currentAccount = this.getCurrentAccountData();

    if (currentAccount) {
      this.summaryCards[0].value = this.formatCurrency(currentAccount.current_balance || 0);
      this.summaryCards[1].value = this.formatCurrency(currentAccount.available_balance || 0);
    }
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  }



  // Recent transactions data
  displayedTransactionColumns: string[] = ['date', 'primaryCategory', 'categoryDetail', 'status', 'taxPercent', 'amount'];
  dataSource = new MatTableDataSource<RecentTransaction>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Pagination logic
  currentPage = 1;
  pageSize = 10; // entries per page
  totalEntries = 0;
  totalPages = Math.ceil(this.totalEntries / this.pageSize);
  allTransactions: RecentTransaction[] = []; // Store all transactions
  filteredTransactions: RecentTransaction[] = []; // Store filtered transactions
  displayedTransactions: RecentTransaction[] = []; // Store currently displayed transactions
  hasMoreTransactions = false;

  visiblePages: number[] = [];
  chunkSize = 3; // number of page buttons visible

  get startEntry() {
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get endEntry() {
    return Math.min(this.currentPage * this.pageSize, this.totalEntries);
  }

  get hasMoreData() {
    return this.displayedTransactions.length < this.filteredTransactions.length;
  }

  ngOnInit() {
    // Set the page header title and subtitle
    this.headerService.setHeader(
      environment.pageHeaders.transactions.title,
      environment.pageHeaders.transactions.description
    );

    // Set default month to current month
    this.setDefaultCurrentMonth();

    // Pagination setup
    this.updateVisiblePages();
    this.dataSharingService.getSalesforceAccountDetails('123').subscribe((res) => {
      console.log(res, 'salesforce account details');
      const result = res?.data?.result;

      // Populate accounts list dynamically
      this.accountsList = result?.accounts ?? [];

      // Show dropdown only if more than one account
      this.showAccountDropdown = this.accountsList.length > 1;

      // Set default selected account
      if (this.accountsList.length > 0) {
        this.selectedAccount = this.accountsList[0].account_name + ' - ' + this.accountsList[0].acct_last_4;
        this.accountChanged.emit(this.selectedAccount);
        this.updateSummaryCards();
      }

      const txns: any[] = result?.transactions ?? [];

      const rows: RecentTransaction[] = txns.map((t, i) => ({
        id: i + 1,
        date: t.sys_date || '',
        primaryCategory: (t.category || '—').trim() || '—',
        categoryDetail: t.descr || '—',
        status: t.status || '—',
        taxPercent: 0,
        amount: typeof t.amount === 'number' ? t.amount : 0
      }));

      // Store all transactions
      this.allTransactions = rows;

      // Apply month filter after loading data
      this.filterTransactionsByMonth();
    });
  }

  updateVisiblePages() {
    const chunkIndex = Math.floor((this.currentPage - 1) / this.chunkSize);
    const startPage = chunkIndex * this.chunkSize + 1;
    const endPage = Math.min(startPage + this.chunkSize - 1, this.totalPages);

    this.visiblePages = [];
    for (let i = startPage; i <= endPage; i++) {
      this.visiblePages.push(i);
    }
  }


  loadMoreTransactions() {
    const currentDisplayedCount = this.displayedTransactions.length;
    const nextBatchSize = Math.min(this.pageSize, this.filteredTransactions.length - currentDisplayedCount);

    if (nextBatchSize > 0) {
      const nextBatch = this.filteredTransactions.slice(currentDisplayedCount, currentDisplayedCount + nextBatchSize);
      this.displayedTransactions = [...this.displayedTransactions, ...nextBatch];
      this.dataSource.data = this.displayedTransactions;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateVisiblePages();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateVisiblePages();
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.updateVisiblePages();
  }



  async showTransactionDetails(event: Event) {
    console.log('Transaction item clicked', event);
    // Implement the logic to show transaction details
    const modal = await this.modalCtrl.create({
      component: TransactionDetailsComponent,
      cssClass: 'transaction-details-modal-wrapper',
    });
    await modal.present();
  }
}
